import _toConsumableArray from "/Users/drjova/projects/giogos/giogos.ch/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/Users/drjova/projects/giogos/giogos.ch/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {0|1|2} Severity
 * @typedef {'warn'|'on'|'off'|'error'} Label
 * @typedef {[Severity, ...Array<unknown>]} SeverityTuple
 *
 * @typedef RuleMeta
 * @property {string} origin name of the lint rule
 * @property {string} [url] link to documentation
 *
 * @callback Rule
 * @param {Node} tree
 * @param {VFile} file
 * @param {unknown} options
 * @returns {void}
 */

import { wrap } from 'trough';
var primitives = new Set(['string', 'number', 'boolean']);

/**
 * @param {string|RuleMeta} meta
 * @param {Rule} rule
 */
export function lintRule(meta, rule) {
  var id = typeof meta === 'string' ? meta : meta.origin;
  var url = typeof meta === 'string' ? undefined : meta.url;
  var parts = id.split(':');
  // Possibly useful if externalised later.
  /* c8 ignore next */
  var source = parts[1] ? parts[0] : undefined;
  var ruleId = parts[1];
  Object.defineProperty(plugin, 'name', {
    value: id
  });
  return plugin;

  /** @type {import('unified').Plugin<[unknown]|Array<void>>} */
  function plugin(raw) {
    var _coerce = coerce(ruleId, raw),
      _coerce2 = _slicedToArray(_coerce, 2),
      severity = _coerce2[0],
      options = _coerce2[1];
    if (!severity) return;
    var fatal = severity === 2;
    return function (tree, file, next) {
      var index = file.messages.length - 1;
      wrap(rule, function (error) {
        var messages = file.messages;

        // Add the error, if not already properly added.
        // Only happens for incorrect plugins.
        /* c8 ignore next 6 */
        // @ts-expect-error: errors could be `messages`.
        if (error && !messages.includes(error)) {
          try {
            file.fail(error);
          } catch (_unused) {}
        }
        while (++index < messages.length) {
          Object.assign(messages[index], {
            ruleId: ruleId,
            source: source,
            fatal: fatal,
            url: url
          });
        }
        next();
      })(tree, file, options);
    };
  }
}

/**
 * Coerce a value to a severity--options tuple.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {SeverityTuple}
 */
function coerce(name, value) {
  /** @type {Array<unknown>} */
  var result;
  if (typeof value === 'boolean') {
    result = [value];
  } else if (value === null || value === undefined) {
    result = [1];
  } else if (Array.isArray(value) &&
  // `isArray(unknown)` is turned into `Array<any>`:
  // type-coverage:ignore-next-line
  primitives.has(typeof value[0])) {
    // `isArray(unknown)` is turned into `Array<any>`:
    // type-coverage:ignore-next-line
    result = _toConsumableArray(value);
  } else {
    result = [1, value];
  }
  var level = result[0];
  if (typeof level === 'boolean') {
    level = level ? 1 : 0;
  } else if (typeof level === 'string') {
    if (level === 'off') {
      level = 0;
    } else if (level === 'on' || level === 'warn') {
      level = 1;
    } else if (level === 'error') {
      level = 2;
    } else {
      level = 1;
      result = [level, result];
    }
  }
  if (typeof level !== 'number' || level < 0 || level > 2) {
    throw new Error('Incorrect severity `' + level + '` for `' + name + '`, ' + 'expected 0, 1, or 2');
  }
  result[0] = level;

  // @ts-expect-error: it’s now a valid tuple.
  return result;
}